// import { createContext, useContext, useEffect, useState } from "react";
// import { auth } from "@/firebase";
// import { onAuthStateChanged, signOut } from "firebase/auth";

// const AuthContext = createContext(null);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsub = onAuthStateChanged(auth, (firebaseUser) => {
//       const loginTime = localStorage.getItem("loginTime");

//       // 🔥 Block invalid sessions
//       if (firebaseUser && !loginTime) {
//         signOut(auth);
//         setUser(null);
//       } else {
//         setUser(firebaseUser);
//       }

//       setLoading(false);
//     });

//     return () => unsub();
//   }, []);

//   const logout = async () => {
//     await signOut(auth);
//     localStorage.removeItem("loginTime");
//   };

//   return (
//     <AuthContext.Provider value={{ user, loading, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { auth } from "@/firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔥 Track first auth boot
  const initialised = useRef(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {

      // FIRST auth event → allow it
      if (!initialised.current) {
        initialised.current = true;
        setUser(firebaseUser);
        setLoading(false);
        return;
      }

      // Subsequent auth events
      if (!firebaseUser) {
        setUser(null);
        setLoading(false);
        return;
      }

      const loginTime = localStorage.getItem("loginTime");

      // 🚫 Block only AFTER first boot
      if (!loginTime) {
        signOut(auth);
        setUser(null);
      } else {
        setUser(firebaseUser);
      }

      setLoading(false);
    });

    return () => unsub();
  }, []);

  const logout = async () => {
    await signOut(auth);
    localStorage.removeItem("loginTime");
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
